import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Comprehensive validator for image documents.
 * Validates that:
 * 1. Each document entry has a file selected
 * 2. There is exactly one primary image (if image exists)
 * @param control The form control containing the images and documents.
 * @returns Validation errors for missing files, no primary image, or multiple primary images.
 */
export const imageDocumentValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const items = control.value || [];

  if (items.length === 0) {
    return null;
  }

  const errors: ValidationErrors = {};

  // Check if any item is missing a file
  const hasInvalidItems = items.some(
    (item: any) => !item.file || !item.file.name
  );

  if (hasInvalidItems) {
    errors.missingFile = true;
  }

  // Helper function to check if file is an image
  const isImage = (item: any) => {
    if (!item.file || !item.file.type) return false;
    return item.file.type.startsWith('image/');
  };

  // Filter only images for primary validation
  const images = items.filter(isImage);

  // Check primary image validation only for images
  if (images.length > 0) {
    const primaryCount = images.filter((img: any) => img.isPrimary).length;

    if (primaryCount === 0) {
      errors.noPrimary = true;
    }

    if (primaryCount > 1) {
      errors.multiplePrimary = true;
    }
  }

  return Object.keys(errors).length > 0 ? errors : null;
};
